import { useSuspenseQuery } from '@connectrpc/connect-query'
import { useTranslation } from 'react-i18next'

import { listApiKeys } from '~/gen/proto/bff/v1/admin-BffAdminService_connectquery'
import { ApiKey } from '~/gen/proto/bff/v1/model_pb'

export function useApiKeys(): ApiKey[] {
  const { t } = useTranslation()
  const res = useSuspenseQuery(
    listApiKeys,
    {},
    {
      select: (data) => data.apiKeys,
    },
  )
  if (res.isError || res.data === undefined) {
    throw new Error(t('message.fetchFail', { entity: t('domain.apikey') }))
  }
  return res.data
}
